export default __webpack_public_path__ + "static/media/profile_home.b133cbbf.jpg";